<template>
  <transition name="slide">
    <CCard>
      <CCardBody>
        <CButton color="primary" @click="create()"
          ><CIcon name="cil-plus" /> Create New Contract</CButton
        >
        <br />
        <br />
        <br />

        <CAlert :color="alertType" v-if="message"> {{ message }}</CAlert>

        <CDataTable
          :items="items"
          :fields="fields"
          :items-per-page="50"
          hover
          pagination
        >
          <template #status="{ item }">
            <td>
              <CBadge :color="getBadge(item.active)">
                {{ item.active == true ? "Active" : "Inactive" }}
              </CBadge>
            </td>
          </template>
          <template #name="{ item }">
            <td style="width: 40%">
              <strong>{{ item.name }}</strong>
            </td>
          </template>
          <template #createDate="{ item }">
            <td>
              {{ moment(new Date(item.createDate)).format($dateFormat) }}
            </td>
          </template>
          <template #EDIT="{ item }">
            <td>
              <CButton color="primary" @click="edit(item.id)"
                ><CIcon name="cil-pencil" /> Edit</CButton
              >
            </td>
          </template>
          <template #DELETE="{ item }">
            <td>
              <CButton
                color="danger"
                @click="
                  warningModal = true;
                  contract = item;
                "
                ><CIcon name="cil-trash" /> Delete</CButton
              >
            </td>
          </template>
        </CDataTable>
        <CModal
          v-model="contract.id"
          title="Are you sure to delete contract?"
          color="danger"
          :show.sync="warningModal"
          @update:show="closeModal"
        >
          <CRow>
            <CCol col="6">
              <CInput label="Description" v-model="contract.description" disabled />
            </CCol>
            <CCol col="12">
              <CInput label="Commission Rate" v-model="contract.commissionRate" disabled />
            </CCol>
          </CRow>
        </CModal>
      </CCardBody>
    </CCard>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "Contracts",

  data: () => {
    return {
      // use uuuid
      emptyGuid: "00000000-0000-0000-0000-000000000000",
      fields: ["status", "description", "commissionRate","createDate", "partnerName", "EDIT", "DELETE"],

      warningModal: false,
      contract: [],

      // Alert
      alertType: "danger",
      message: null,

      // List
      items: [],
    };
  },
  computed: {},
  methods: {
    getBadge(status) {
      switch (status) {
        case true:
          return "success";
        case false:
          return "secondary";
        default:
          return "primary";
      }
    },

    closeModal(status, evt, accept) {
      if (accept) {
        this.delete(this.contract.id);
      }
    },

    edit(id) {
      this.$router.push({ path: `contracts/create/${id}` });
    },
    delete(id) {
      let self = this;
      axios
        .delete(this.$apiAdress + "/v1/Contract/" + id)

        .then(function () {
                    self.alertType = "success";
          setTimeout(function () {
              self.message = null;
          }, 5000);
          self.message = "Successfully deleted contract.";
          self.getList();
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
    create() {
      this.$router.push({ path: "/contracts/create/" + this.emptyGuid });
    },

    getList() {
      let self = this;
      axios
        .get(this.$apiAdress + "/v1/Contract")
        .then(function (response) {
          self.items = response.data;
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
  },
  mounted: function () {
    this.getList();
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
